export enum TotpState {
  Unconfigured = 0,
  Pending = 1,
  Enabled = 2,
  Disabled = 3,
}

export enum MfaProofType {
  Totp = 1,
  Recovery = 2,
}
